/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpacksampleloading3Inputs */

const en_artifactpacksampleloading3 = /** @type {(inputs: Artifactpacksampleloading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening sample…`)
};

const pt_artifactpacksampleloading3 = /** @type {(inputs: Artifactpacksampleloading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A abrir exemplo…`)
};

/**
* | output |
* | --- |
* | "Opening sample…" |
*
* @param {Artifactpacksampleloading3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpacksampleloading3 = /** @type {((inputs?: Artifactpacksampleloading3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpacksampleloading3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpacksampleloading3(inputs)
	return pt_artifactpacksampleloading3(inputs)
});
export { artifactpacksampleloading3 as "artifactPackSampleLoading" }